import React from 'react';

import { Main } from './components';

export const PortfolioCompanyCovenantTrackingPage: React.FC = () => {
  return <Main />;
};
